import BaseCrudRepository from '@/repositories/BaseCrudRepository';
import LibraryItemTranslation from '@/repositories/data/libraryitem/LibraryItemTranslation';
import HttpClient from '@/util/http/HttpClient';

export default class LibraryItemTranslationRepository extends BaseCrudRepository<
    number,
    LibraryItemTranslation,
    LibraryItemTranslation
> {
    constructor(client: HttpClient) {
        super(client, 'rest/admin/library-item-translation');
    }
}
